<template>
    <v-dialog v-model="dialog" persistent max-width="900px">
        <v-card>
            <v-card-title>
                <span class="text-h6">{{ comisionData.ComisionPlanificacionId ? 'Editar' : 'Agregar' }} Comisión
                    Planificación</span>
            </v-card-title>

            <v-card-text>
                <v-container>
                    <v-row dense>
                        <v-col cols="4">
                            <PersonaBuscador v-model="comision.dniDocente" label="Ingrese el DNI de la persona"
                                @personas:change="changePersona"></PersonaBuscador>
                        </v-col>
                        <v-col cols="2">
                            <v-text-field v-model="comision.codigo" label="Codigo"
                                hint='Numero Codigo de la asignatura ' />
                        </v-col>
                        <v-col cols="6">
                            <v-text-field v-model="comision.asignatura" label="Asignatura" />
                        </v-col>
                        <v-col cols="8">
                            <v-text-field v-model="comision.nombreComision" label="Nombre Comisión" />
                        </v-col>
                        <v-col cols="4">
                            <v-text-field v-model="comision.grupo" label="Grupo" hint="Combinacion de 'Modalidad + Sede + Carrera + Cuatrimestre + Comision'" />
                        </v-col>
                        <v-col cols="3">
                            <v-select :items="modalidades" v-model="comision.modalidad" label="Modalidad"
                                item-text="nombre" item-value="modalidad"></v-select>
                        </v-col>
                        <v-col cols="2">
                            <v-select :items="sedes" v-model="comision.sede" label="Sede"></v-select>
                        </v-col>
                        <v-col cols="2">
                            <v-select :items="carreras" v-model="comision.carrera"
                                label="Carrera"></v-select>
                        </v-col>

                        <v-col cols="1">
                            <v-text-field v-model="comision.año" label="Año" type="number" hint="Año de la asignatura"
                                min=0 max=5 oninput="if(Number(this.value) > Number(this.max)) this.value = this.max" />
                        </v-col>
                        <v-col cols="2">
                            <v-text-field v-model="comision.cuatrimestre" label="Cuatrimestre" type="number"
                                hint='Numero Cuatrimestre de la asignatura ' />
                        </v-col>
                        <v-col cols="2">
                            <v-text-field v-model="comision.comision" label="Comisión" hint='Ejemplo: "A", "B" etc.' />
                        </v-col>

                        <v-col cols="3">
                            <v-text-field v-model="comision.fusion" label="Fusión"
                                hint='Nombre que une comisiones. Ejemplo "DAP1, MAT1, ECO2' />
                        </v-col>
                        <v-col cols="2">

                            <v-menu ref="menuRef" v-model="menuHorario" :close-on-content-click="false"
                                :nudge-right="40" :return-value.sync="comision.horario" transition="scale-transition"
                                offset-y max-width="290px" min-width="290px">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field label="Horario" v-model="comision.horario"
                                        prepend-icon="mdi-clock-time-four-outline" readonly v-bind="attrs"
                                        v-on="on"></v-text-field>
                                </template>
                                <v-time-picker v-model="comision.horario" @change="$refs.menuRef.save(comision.horario)"
                                    format="24hr"></v-time-picker>
                            </v-menu>

                        </v-col>
                        <v-col cols="3">
                            <v-text-field v-model="comision.cantidadEncuentros" label="Cantidad de Encuentros"
                                type="number" />
                        </v-col>

                        <v-col cols="3">
                            <v-text-field v-model="comision.semanaDistanciaId" label="Semana Distancia ID" type="number"
                                hint='Codigo ( 1 o 2 ) de la semana a Distancia, si es SEMI dejar vacia.' />
                        </v-col>




                        <!-- <v-col cols="6">
                            <v-menu ref="startDateMenu" v-model="startDateMenu" :close-on-content-click="false"
                                :nudge-right="40" transition="scale-transition" offset-y max-width="290px"
                                min-width="290px">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field v-model="formattedStartDate" label="Fecha de Inicio" readonly
                                        v-bind="attrs" v-on="on" />
                                </template>
                                <v-date-picker v-model="comision.FechaInicio" @input="startDateMenu = false" />
                            </v-menu>
                        </v-col>
                        <v-col cols="6">
                            <v-menu ref="endDateMenu" v-model="endDateMenu" :close-on-content-click="false"
                                :nudge-right="40" transition="scale-transition" offset-y max-width="290px"
                                min-width="290px">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field v-model="formattedEndDate" label="Fecha de Fin" readonly
                                        v-bind="attrs" v-on="on" />
                                </template>
                                <v-date-picker v-model="comision.FechaFin" @input="endDateMenu = false" />
                            </v-menu>
                        </v-col> -->
                    </v-row>
                    <v-row>
                        <v-col cols="3">
                            <v-select :items="strDias" v-model="comision.diaDisponibilidad"
                                label="Seleccione un dia"></v-select>
                        </v-col>
                        <v-col cols="4">
                            <v-menu ref="startDateMenu" v-model="startDateMenu" :close-on-content-click="false"
                                :nudge-right="40" transition="scale-transition" offset-y max-width="290px"
                                min-width="290px">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field v-model="formattedStartDate" label="Fecha de Inicio" readonly
                                        v-bind="attrs" v-on="on" />
                                </template>
                                <v-date-picker v-model="comision.fechaInicio" @input="startDateMenu = false" />
                            </v-menu>
                        </v-col>
                        <v-col cols="4">
                            <v-menu ref="endDateMenu" v-model="endDateMenu" :close-on-content-click="false"
                                :nudge-right="40" transition="scale-transition" offset-y max-width="290px"
                                min-width="290px">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field v-model="formattedEndDate" label="Fecha de Fin" readonly
                                        v-bind="attrs" v-on="on" />
                                </template>
                                <v-date-picker v-model="comision.fechaFin" @input="endDateMenu = false" />
                            </v-menu>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>

            <v-card-actions>
                <v-spacer />
                <v-btn color="blue darken-1" text @click="saveChanges">Guardar</v-btn>
                <v-btn color="red darken-1" text @click="cerrar">Cancelar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import PersonaBuscador from '../persona/PersonaBuscador.vue'
import Planificador from "../../services/Planificador.service";
export default {
    components: { PersonaBuscador },
    props: {
        dialog: {
            type: Boolean,
            default: false
        },
        comisionData: {
            type: Object,
            default: {}
            /* 
            () => ({
                "ComisionPlanificacionId": 5,
                "DocenteId": 1,
                "DniDocente": 99,
                "Carrera": "LL",
                "Codigo": 3,
                "Asignatura": "MATEMATICA I",
                "Modalidad": "D",
                "Año": 1,
                "Cuatrimestre": 1,
                "CantidadEncuentros": 7,
                "Fusion": null,
                "SemanaDistanciaId": 2,
                "FechaInicio": "2025-03-17T03:00:00.000Z",
                "FechaFin": "2025-06-13T03:00:00.000Z",
                "DiaDisponibilidad": null,
                "Horario": "20:00",
                "Sede": "COR",
                "Comision": "D",
                "NombreComision": "24-1-LL-MAT1-COR-DIST-D",
                "Grupo": "CORLL1D",
                "Semestre": 12025
            }), */
        },
    },
    data() {
        return {
            strDias: ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sádabo"],
            menuHorario: false,
            modalidades: [
                { nombre: "Semipresencial", modalidad: 'S' },
                { nombre: "Distancia", modalidad: 'D' },
            ],
            carreras: ['CP', 'IS', 'LA', 'LL', 'RH', 'TUDAI'],
            sedes: ['BEL', 'COR', 'JES'],
            startDateMenu: false,
            endDateMenu: false,
            comision: {},
        };
    },
    watch: {
  comisionData: {
    immediate: true,
    handler(value) {
      if (!value) return

      const clone = JSON.parse(JSON.stringify(value))

      clone.fechaInicio = clone.fechaInicio
        ? clone.fechaInicio.substring(0, 10)
        : null

      clone.fechaFin = clone.fechaFin
        ? clone.fechaFin.substring(0, 10)
        : null

      this.comision = clone
    }
  }
},
    computed: {
        formattedStartDate() {
            const fechaInicio = this.comision?.fechaInicio;
            if (!fechaInicio) return "";
            // Asegurarse de trabajar con el formato esperado y convertir la fecha
            const [datePart] = fechaInicio.split("T");
            const formattedDate = new Date(`${datePart}T00:00:00`).toLocaleDateString('en-GB');
            return formattedDate;
        },
        formattedEndDate() {
            const fechaFin = this.comision?.fechaFin;
            if (!fechaFin) return "";
            // Asegurarse de trabajar con el formato esperado y convertir la fecha
            const [datePart] = fechaFin.split("T");
            const formattedDate = new Date(`${datePart}T00:00:00`).toLocaleDateString('en-GB');
            return formattedDate;
        },
    },
    methods: {
        changePersona(value) {
            console.log("editor:"+value[0].id);
            if (value) {
                this.personas = value;
                this.comision.docenteId = value[0].id;
            }
        },
        saveChanges() {
            Planificador.ActualizarComiPlani(this.comision).then((result) => {
                this.$emit("actualizado", true);
                this.$toast.success("Comision actualizada.");
            }).catch((err) => {
                try {
                    const mensajes = Object.values(err.response.data.errors)
                        .flat()
                        .join('<br>');
                    this.$toast.error(mensajes);
                } catch (error) {
                    this.$toast.error(err.response.data);
                }
            });;
        },
        cerrar() {
            this.$emit("actualizado", false);
        },
    },
};
</script>

<style scoped></style>
